export default function crashlytics() {
    return {
        setUserId() { },
        setAttributes() { },
        log() { },
        recordError() { },
    };
}
